module.exports = __webpack_public_path__ + "img/sub-img.41b99348.svg";